import React, { Component } from "react";
import LoaderModal from "../../../../components/modal/LoaderModal";
import utilManagement from "../../../../apis/utilManagement";
import jsonFile from "../sekolah/report_ensa_sekolah.json";
import { Pie, Scatter } from "react-chartjs-2";
import {
    ReportHeader,
    CardProfile,
    EnsaCard,
    ChartLabel,
    LabelChartProgresLiterasi,
    LabelChartKeteranganProgLit,
    TableLiterasiSiswaPotensi,
    ChartP3,
    EnsaCard2,
    ChartKesenjanganGenderSk,
} from "../index";
import {
    GaugeDoughnut,
    ChartLineProgresLiterasi,
    PieChart,
    ChartLineKesenjanganLiterasi,
    ChartLineStatusSosialLiterasi,
    ChartBublePosSekolah,
    ChartBar,
    ChartBublePosSekolahSK,
    ChartBublePosSekolahSlb,
    PackedChart,
    TreemapChart,
    MapChart,
} from "../../../../components/Global";
import EnsaConstant from "../EnsaConstant";
import { CONFIG_UTIL } from "../../../../config";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import { Alert } from "react-bootstrap";

class ReportSekolah extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            alertShow: false,
            error: false,
            dataMaps: {
                daerah: [],
                nasional: []
            },
            dataSekolah: {},
            dataLiterasiIndeks: {
                mapels: []
            },
            dataLiterasiAllIdx: {},
            easypiechartId: ['easypiechart-blue', 'easypiechart-red', 'easypiechart-green'],
            prosentasiCapaianKompetensi: [],
            dataProgresLiterasi: {
                progresIndex: {
                    skor: [],
                    prosentase: 0,
                    rangeTahun: [],
                    dataKeterangan: []
                },
                progresCapaian: {
                    skor: [],
                    prosentase: 0,
                    rangeTahun: [],
                    dataKeterangan: []
                }
            },
            dataLiterasiLevel: [],
            dataKesenjanganLiterasi: {
                title: [],
                literasiGender: {},
                literasiSosialEkonomi: {}
            },
            dataPosisiSekolah: {
                title: [],
                outer: [],
                nonOuter: [],
                ensa: {
                    key: '',
                    value: 0,
                },
                will: {
                    key: '',
                    value: 0,
                }
            },
            dataSiswaPotensiDarurat: {
                potensi: [],
                darurat: []
            },
            kesenjanganSkGender: [],
            dataRaportSk: {
                karakterDimensi: [],
                prosentaseHasilSK: [],
                temaProjek: [],
                posisiSekolah: [],
                kesenjanganSkGender: [],
                kesenjanganSKStatus2: [],
                kesenjanganSKStatus: {
                    kritis: {
                        listData: []
                    },
                    kreatif: {
                        listData: []
                    },
                    coop: {
                        listData: []
                    },
                    mandiri: {
                        listData: []
                    },
                    bhineka: {
                        listData: []
                    },
                    religi: {
                        listData: []
                    },
                },
            },
            dataReportSlb: {
                kualitasPembelajaran: {
                    value: []
                },
                iklimKeamananSekolah: {
                    value: []
                },
                iklimKebinekaan: {
                    value: []
                },
                posisiSekolah: [],
                kesenjanganGender: [],
                kesenjanganStatus: [],
                dataBulat: []
            }
        };
    }

    async componentDidMount() {
        this.setState({
            isFetching: true,
        });
        this.getReport();

        let elementIdWatermark = ["id-82-title", "id-181-title"]
        elementIdWatermark.flatMap((el) => {
            var element = document.querySelector('[aria-labelledby="' + el + '"]');
            if (element) {
                element.remove();
            }
        })
    }

    filterByName(listData, key) {
        let result = null
        for (let i in listData) {
            const item = listData[i]
            if (item.key == key) {
                result = item
                break
            }
        }
        return result
    }
    loadAlert = () => {
        const { alertShow } = this.state;

        if (alertShow) {
            return (
                <Alert variant="warning" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    };

    async getReport() {
        const id = this.props.history.location.pathname.split("/");
        const response = await utilManagement.post(CONFIG_UTIL.REPORT_ENSA_SEKOLAH, {
            "idJadwalCbt": id[2],
            "idSekolah": id[3],
            "idKelas": id[4],
            "idKelasParalel": id[5],
            "tahunAjaran": id[6].concat('/').concat(id[7])
        })
        // const respJson = jsonFile.data;
        if (response) {
            const res = response.data.data;
            this.setState({
                isFetching: false,
                dataSekolah: res.dataSekolah,
                dataLiterasiIndeks: res.literasiIndeks,
                dataLiterasiAllIdx: res.literasiIndeks.overall[0],
                prosentasiCapaianKompetensi: res.prosentasiCapaianKompetensi,
                dataProgresLiterasi: res.progresLiterasi,
                dataLiterasiLevel: res.levelLiterasi,
                dataKesenjanganLiterasi: res.kesenjanganLiterasi,
                dataPosisiSekolah: res.posisiSekolah,
                dataSiswaPotensiDarurat: res.siswaPotensiDarurat,
                dataRaportSk: res.raportSK,
                dataReportSlb: res.raportSLB,
                dataBulat: res.dataBulat,
                kesenjanganSkGender: res.raportSK.kesenjanganSkGender,
                dataMaps: res.maps,
            });
        } else {
            this.setState({
                isFetching: false,
                error: true,
                alertShow: true,
                resMessage: response.data.errorSchema.errorMessage,
            });
        }
        (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "/assets/js/easypiechart-data.js";
            document.getElementsByTagName("head")[0].appendChild(script);
        })();
    }

    render() {
        require("./ReportSekolah.css");
        const { isFetching,
            dataSekolah,
            dataLiterasiIndeks,
            dataLiterasiAllIdx,
            easypiechartId,
            prosentasiCapaianKompetensi,
            dataProgresLiterasi,
            dataLiterasiLevel,
            dataKesenjanganLiterasi,
            dataPosisiSekolah,
            dataSiswaPotensiDarurat,
            dataRaportSk,
            dataReportSlb,
            kesenjanganSkGender,
            dataMaps
        } =
            this.state;
        return (
            <div>
                <LoaderModal isFetching={isFetching} />
                {this.loadAlert()}
                {/* page 1 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={1} />

                    <div className="cardLine">
                        <div className="flex-pln-profile">
                            <CardProfile
                                label={"Nama Sekolah"}
                                value={dataSekolah.namaSekolah}
                                iconImage={"/assets/image/icon-sekolah.svg"}
                            />
                            <CardProfile
                                label={"Kelas"}
                                value={dataSekolah.namaKelas}
                                iconImage={"/assets/image/icon-kelas.svg"}
                            />
                            <CardProfile
                                label={"Jumlah Siswa"}
                                value={dataSekolah.jumsis == null ? '' : dataSekolah.jumsis}
                                iconImage={"/assets/image/jumlah-siswa.svg"}
                            />
                            <CardProfile
                                label={"Tgl Asesmen"}
                                value={dataSekolah.jadwalMulai}
                                iconImage={"/assets/image/mdi_date.svg"}
                            />
                        </div>
                    </div>

                    <EnsaCard title="Peta Peserta ENSA Nasional">
                        <MapChart id="chartEnsa" dataset={dataMaps.nasional}></MapChart>
                    </EnsaCard>
                    <EnsaCard title="Peta Peserta ENSA Kota / Kabupaten">
                        <MapChart id="chartEnsaKota" dataset={dataMaps.daerah}></MapChart>
                    </EnsaCard>
                </div>

                {/* page 2 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={2} />

                    <div className="cardLine">
                        <div className="point-title">Rapor Performa Literasi</div>
                    </div>

                    <EnsaCard title="A. Performa Literasi berdasarkan Indeks">
                        <div className="chart-container">
                            <GaugeDoughnut
                                className="chart-overall-index"
                                id="gaugeNeedle"
                                valueChart={[dataLiterasiAllIdx.value, 3 - dataLiterasiAllIdx.value]}
                                chartColor={["#015E56", "#C9FCD1"]}
                                skor={dataLiterasiAllIdx.value}
                                chartLabel="Overall Index"
                                description="Mencapai Kompetensi Minimum"
                            />
                            <div className="chart-literasi">

                                {dataLiterasiIndeks.mapels.map((item, i) => (
                                    <div key={i}>
                                        <GaugeDoughnut
                                            className="chart-gauge"
                                            id="gaugeNeedle"
                                            skor={item.value}
                                            valueChart={[item.value, 3 - item.value]}
                                            chartColor={[item.keterangan == 'atas' ? "#03C46B" : '#FF3838', "#E8E9E7"]}
                                        >
                                            <ChartLabel
                                                title={item.key}
                                                desc={item.description}
                                                type={item.key}
                                            />
                                        </GaugeDoughnut>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </EnsaCard>
                    <EnsaCard title="B. Performa Literasi berdasarkan Capaian">
                        <div className="flex-pnl-around">
                            {prosentasiCapaianKompetensi.map((item, index) => (
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: '18px', textAlign: 'center' }}>{item.key}</div>
                                    <div className="easypiechart chart" id={easypiechartId[index]} data-percent={item.scoreIndexCurrent}>
                                        <div className="label_persentase_potensi_chart" style={{ paddingTop: '68px' }}>
                                            <span className="persentase_potensi">{item.scoreIndexCurrent}%</span>
                                            <br />
                                        </div>
                                    </div>
                                    <ChartLabel
                                        skor={item.scoreIndexCurrent}
                                        desc={item.description}
                                        type={item.status}
                                    />
                                </div>
                            ))}
                        </div>
                    </EnsaCard>

                </div>
                {/* page 3 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={3} />
                    <EnsaCard title="C. Progres Performa Literasi">
                        <div className="flex-pnl-between">
                            <div className="pnl-chartLine" style={{ borderRight: '2px solid #015E56' }}>
                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                    <span className="tit-card-perfomlit">1. Progress Performa Literasi-Indeks</span>
                                </div>
                                <LabelChartProgresLiterasi title={'Indeks'} skor={dataProgresLiterasi.progresIndex.skor} prosentase={dataProgresLiterasi.progresIndex.prosentase} />
                                <ChartLineProgresLiterasi dataProgres={dataProgresLiterasi.progresIndex.dataKeterangan} ranges={dataProgresLiterasi.progresIndex.rangeTahun} height={200} />
                                <LabelChartKeteranganProgLit listData={dataProgresLiterasi.progresIndex.dataKeterangan} sekolah={dataSekolah.namaSekolah} />
                            </div>
                            <div className="pnl-chartLine">
                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                    <span className="tit-card-perfomlit">2. Progress Performa Literasi-Capaian</span>
                                </div>
                                <LabelChartProgresLiterasi title={'Indeks'} skor={dataProgresLiterasi.progresCapaian.skor} prosentase={dataProgresLiterasi.progresCapaian.prosentase} />
                                <ChartLineProgresLiterasi dataProgres={dataProgresLiterasi.progresCapaian.dataKeterangan} ranges={dataProgresLiterasi.progresCapaian.rangeTahun} height={200} />
                                <LabelChartKeteranganProgLit listData={dataProgresLiterasi.progresCapaian.dataKeterangan} sekolah={dataSekolah.namaSekolah} />
                            </div>
                        </div>
                    </EnsaCard>
                    <EnsaCard title="D. Performa Literasi berdasarkan Level">
                        <div className="flex-pnl-around">
                            {dataLiterasiLevel.map((item, i) => (
                                <div style={{ textAlign: 'center' }} key={i}>
                                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                                        <div className="chart-label" style={{
                                            backgroundColor: item.key == 'LITERASI MEMBACA' ? EnsaConstant.COLOR.GREEN
                                                : item.key == 'LITERASI SAINS' ? EnsaConstant.COLOR.YELOW : EnsaConstant.COLOR.BLUE
                                        }}>{item.key}</div>
                                    </div>
                                    <PieChart id={"pieChartLv" + i} dataSkor={item.value} />
                                </div>
                            ))}
                        </div>
                    </EnsaCard>

                </div>
                {/* page 4 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={4} />
                    <EnsaCard title="E. Kesenjangan Performa Literasi">
                        <div className="flex-pnl-between">
                            <div style={{ width: '40%' }}>
                                <div className="label-value-profil" style={{ fontSize: '16px', textAlign: 'center', marginBottom: '15px' }}>1. Kesenjangan Performa Literasi-Gender</div>
                                <ChartLineKesenjanganLiterasi dataProgres={dataKesenjanganLiterasi.literasiGender} listTitle={dataKesenjanganLiterasi.title} />
                            </div>
                            <div style={{ width: '60%' }}>
                                <div className="label-value-profil" style={{ fontSize: '16px', textAlign: 'center', marginBottom: '15px' }}>2. Kesenjangan Performa Literasi-Status Sosial Ekoomi</div>
                                <ChartLineStatusSosialLiterasi dataProgres={dataKesenjanganLiterasi.literasiSosialEkonomi} listTitle={dataKesenjanganLiterasi.title} />
                            </div>
                        </div>
                    </EnsaCard>
                    <EnsaCard title="F. Posisi sekolah terhadap sekolah lain">
                        <div style={{ with: '100%' }}>
                            <ChartBublePosSekolah listTitle={dataPosisiSekolah.title} outer={dataPosisiSekolah.outer} nonOuter={dataPosisiSekolah.nonOuter} lineEnsa={dataPosisiSekolah.ensa.value} lineWill={dataPosisiSekolah.will.value} />
                        </div>
                    </EnsaCard>
                </div>

                {/* page 5 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={5} />
                    <div className="cardLine">
                        <div className="point-title">Rapor Performa Literasi</div>
                    </div>
                    <div style={{fontSize: '18px', margin: '20px 20px 20px 57px'}}>A. Siswa Potensial Literasi</div>
                    <TableLiterasiSiswaPotensi dataLiterasi={dataSiswaPotensiDarurat} isPotensi={true} hasSekolah={true}/>
                    {/* <EnsaCard title="A. Siswa Potensial Literasi"> */}

                    {/* </EnsaCard> */}
                    {/* <EnsaCard title="B. Siswa Darurat Literasi"> */}
                    <div style={{fontSize: '18px', margin: '20px 20px 20px 57px'}}>B. Siswa Darurat Literasi</div>
                    <TableLiterasiSiswaPotensi dataLiterasi={dataSiswaPotensiDarurat} isPotensi={false} hasSekolah={true} />
                    {/* </EnsaCard> */}
                </div>
                {/* page 6 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={6} />
                    <div className="cardLine">
                        <div className="point-title">Rapor Survei Karakter</div>
                        <div className="flex-pnl-between" style={{ gap: '20px' }}>
                            <EnsaCard2 title="A. Persentase Hasil Survei Karakter" width={40}>
                                <ChartBar dataLiterasi={dataRaportSk.prosentaseHasilSK} />
                            </EnsaCard2>
                            <EnsaCard2 title="B. Karakter berdasarkan Dimensi P3" width={60}>
                                <ChartP3 dataLiterasi={dataRaportSk.karakterDimensi} className={'pnl-p3'} />
                            </EnsaCard2>
                        </div>
                        <div className="flex-pnl-between" style={{ gap: '20px', marginBottom: '0px' }}>
                            <EnsaCard2 title="C. Rekomendasi Tema Project">
                                <ChartKesenjanganGenderSk dataLiterasi={dataRaportSk.temaProjek} />
                            </EnsaCard2>
                            <EnsaCard2 title="D. Posisi sekolah terhadap sekolah lain" width={59}>
                                <ChartBublePosSekolahSK dataProgres={dataRaportSk.posisiSekolah} />
                            </EnsaCard2>
                        </div>
                    </div>
                </div>
                {/* page 7 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={7} />
                    <div className="cardLine">
                        <div className="point-title" style={{ marginBottom: '20px' }}>E. Kesenjangan Survei Karakter</div>
                        <div className="flex-pnl-between" style={{ gap: '20px' }}>
                            <EnsaCard2 title="1. Kesenjangan survei karakter-Gender" width={50}>
                                <TreemapChart id="sk-kesGender" dataset={kesenjanganSkGender}></TreemapChart>
                            </EnsaCard2>
                            <EnsaCard2 title="2. Kesenjangan survei karakter-Status Sosial Ekonomi" width={50}>
                                {/* <PackedBubble data={dataRaportSk.kesenjanganSKStatus} /> */}
                                <div className="pnl-packChart">
                                    {/* {this.renderChartKesenStatus(dataRaportSk.kesenjanganSKStatus)} */}
                                    <div>
                                        <span style={{ fontSize: '20px' }}>{dataRaportSk.kesenjanganSKStatus.kritis.key}</span>
                                        <PackedChart id={'packedChart-kritis'} dataset={dataRaportSk.kesenjanganSKStatus.kritis.value} showLabel={true} size={35} fontSize={18}></PackedChart>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '20px' }}>{dataRaportSk.kesenjanganSKStatus.kreatif.key}</span>
                                        <PackedChart id={'packedChart-kreatif'} dataset={dataRaportSk.kesenjanganSKStatus.kreatif.value} showLabel={true} size={35} fontSize={18}></PackedChart>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '20px' }}>{dataRaportSk.kesenjanganSKStatus.coop.key}</span>
                                        <PackedChart id={'packedChart-goyong'} dataset={dataRaportSk.kesenjanganSKStatus.coop.value} showLabel={true} size={35} fontSize={18}></PackedChart>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '20px' }}>{dataRaportSk.kesenjanganSKStatus.mandiri.key}</span>
                                        <PackedChart id={'packedChart-mandiri'} dataset={dataRaportSk.kesenjanganSKStatus.mandiri.value} showLabel={true} size={35} fontSize={18}></PackedChart>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '20px' }}>{dataRaportSk.kesenjanganSKStatus.bhineka.key}</span>
                                        <PackedChart id={'packedChart-berkebhinekaan'} dataset={dataRaportSk.kesenjanganSKStatus.bhineka.value} showLabel={true} size={35} fontSize={18}></PackedChart>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '20px' }}>{dataRaportSk.kesenjanganSKStatus.religi.key}</span>
                                        <PackedChart id={'packedChart-beriman'} dataset={dataRaportSk.kesenjanganSKStatus.religi.value} showLabel={true} size={35} fontSize={18}></PackedChart>
                                    </div>
                                </div>

                                {/* <div className="pnl-slb1">
                                    {dataRaportSk.kesenjanganSKStatus.map((item, i) => (
                                        <div key={i}>
                                            {item.name}
                                            <PackedChart id={'chart-bulat-' + i} dataset={item.listData}></PackedChart>
                                        </div>
                                    ))}

                                </div> */}
                            </EnsaCard2>
                        </div>
                    </div>
                </div>
                {/* page 8 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={8} />
                    <div className="cardLine">
                        <div className="point-title">Rapor Survei Lingkungan Belajar</div>
                    </div>
                    <EnsaCard title="A. Kualitas Pembelajaran">
                        <div className="flex-pnl-between">
                            <div style={{ width: '25%' }}>
                                <GaugeDoughnut
                                    className="chart-gauge2"
                                    id="gaugeNeedle"
                                    skor={dataReportSlb.kualitasPembelajaran.skor}
                                    valueChart={[dataReportSlb.kualitasPembelajaran.skor, 3 - dataReportSlb.kualitasPembelajaran.skor]}
                                    chartColor={[dataReportSlb.kualitasPembelajaran.color]}
                                >
                                    <div className="point-label">{dataReportSlb.kualitasPembelajaran.key}</div>
                                </GaugeDoughnut>
                            </div>
                            <div style={{ width: '75%', display: 'flex', alignItems: 'center' }}>
                                <ChartP3 dataLiterasi={dataReportSlb.kualitasPembelajaran.value} className={'pnl-slb1'} />
                            </div>
                        </div>
                    </EnsaCard>
                    <EnsaCard title="B. Iklim Keamanan Sekolah">
                        <div className="flex-pnl-between">
                            <div style={{ width: '25%' }}>
                                <GaugeDoughnut
                                    className="chart-gauge2"
                                    id="gaugeNeedle"
                                    skor={dataReportSlb.iklimKeamananSekolah.skor}
                                    valueChart={[dataReportSlb.iklimKeamananSekolah.skor, 3 - dataReportSlb.iklimKeamananSekolah.skor]}
                                    chartColor={[dataReportSlb.iklimKeamananSekolah.color]}
                                >
                                    <div className="point-label">{dataReportSlb.iklimKeamananSekolah.key}</div>
                                </GaugeDoughnut>
                            </div>
                            <div style={{ width: '75%', display: 'flex', alignItems: 'center' }}>
                                <ChartP3 dataLiterasi={dataReportSlb.iklimKeamananSekolah.value} className={'pnl-slb2'} />
                            </div>
                        </div>
                    </EnsaCard>
                    <EnsaCard title="C. Iklim Kebinekaan">
                        <div className="flex-pnl-between">
                            <div style={{ width: '25%' }}>
                                <GaugeDoughnut
                                    className="chart-gauge2"
                                    id="gaugeNeedle"
                                    skor={dataReportSlb.iklimKebinekaan.skor}
                                    valueChart={[dataReportSlb.iklimKebinekaan.skor, 3 - dataReportSlb.iklimKebinekaan.skor]}
                                    chartColor={[dataReportSlb.iklimKebinekaan.color]}
                                >
                                    <div className="point-label">{dataReportSlb.iklimKebinekaan.key}</div>
                                </GaugeDoughnut>
                            </div>
                            <div style={{ width: '75%', display: 'flex', alignItems: 'center' }}>
                                <ChartP3 dataLiterasi={dataReportSlb.iklimKebinekaan.value} className={'pnl-slb3'} />
                            </div>
                        </div>
                    </EnsaCard>
                </div>
                {/* page 9 */}
                <div className="report-page-last">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={9} />
                    <EnsaCard title="D. Posisi sekolah terhadap sekolah lain">
                        <ChartBublePosSekolahSlb dataProgres={dataReportSlb.posisiSekolah} />
                    </EnsaCard>
                    <EnsaCard title="E. Posisi sekolah terhadap sekolah lain">
                        <div className="flex-pnl-between">
                            <div style={{ width: '50%', borderRight: '2px solid #015E56' }}>
                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                    <span className="tit-card-perfomlit">1. Kesenjangan Survei Lingkungan</span>
                                    <p className="tit-card-perfomlit" style={{ fontWeight: '500', marginTop: '10px' }}>Belajar-Gender</p>
                                </div>
                                <TreemapChart id="slb-kesGender" dataset={dataReportSlb.kesenjanganGender}></TreemapChart>
                            </div>
                            <div style={{ width: '50%' }}>
                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                    <span className="tit-card-perfomlit">2. Kesenjangan Survei Lingkungan</span>
                                    <p className="tit-card-perfomlit" style={{ fontWeight: '500', marginTop: '10px' }}>Belajar-Status Sosial Eknomi</p>
                                </div>
                                <TreemapChart id="slb-kesEkonomi" dataset={dataReportSlb.kesenjanganStatus}></TreemapChart>
                            </div>
                        </div>
                    </EnsaCard>
                </div>

                {/* <EnsaCard title="H. Performa dalam Persentil">
                    <div className="flex-pnl-between">
                        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                            <DumbbellPlot id="plotPerforma"></DumbbellPlot>
                        </div>
                    </div>
                </EnsaCard>

                <EnsaCard title="G. Performa dalam Desil Nasional">
                    <div className="flex-pnl-between">
                        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                            <DumbbellPlotDesil id="plotDesuilNasional"></DumbbellPlotDesil>
                        </div>
                    </div>
                </EnsaCard>

                <EnsaCard title="I. Rata-Rata Sekolah-Wilayah-Nasional">
                    <div className="flex-pnl-between">
                        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                            <ScatterChart id="scatter-avg"></ScatterChart>
                        </div>
                    </div>
                </EnsaCard> */}

                <div className="fixedButton">
                    <button className="buttonPrint" onClick={() => {
                        document.title = dataSekolah.namaSekolah;
                        window.print();
                        document.title = 'EduPrime';
                    }}>
                        <img
                            src="/assets/image/print.png"
                            width={22}
                            style={{ marginRight: 5 }}
                            alt=""
                        />
                        Print Report
                    </button>
                </div>
            </div >
        );
    }
}
export default ReportSekolah;
